import noop from 'lodash/noop';

import { useDispatch } from 'react-redux';

import { addFlashMessageError, addFlashMessageNotice } from '../components/FlashMessages/duck';
import { useGlobalContent } from './index';

export default () => {
  const errors = useGlobalContent('error');
  const dispatch = useDispatch();
  return {
    errors,
    getErrorMessage: (fn = noop) => {
      return fn(errors) || errors.general.default;
    },
    sendErrorMessage: (fn = noop) => {
      const message = fn(errors) || errors.general.default;
      return dispatch(addFlashMessageError(message));
    },
    sendWarningMessage: fn => {
      const message = fn(errors);
      return message && dispatch(addFlashMessageNotice(message));
    }
  };
};
